<div class="content-wrapper">
  <section class="content">
    <div class="content-header">
      <app-breadcrumb
        Titulo="Dashboard"
      ></app-breadcrumb>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="tarja-bem-vindo">
          <div class="titulo-tarja">Bem-vindo de volta, {{usuario}}</div>
          <a href="/cadastro/cliente"><div class="button-tarja btn btn-dark">Clientes</div></a>
          <div class="subtitulo-tarja" *ngIf="dashboard.totalClientesUltimoLogin > 0">Total de {{dashboard.totalClientesUltimoLogin}} cadastros de clientes criados</div>
        </div>
      </div>
      <div class="col-md-12" style="border: 1px solid #c1c1c1;">
        <div class="row">
          <div class="col-3 icons">
            <div class="row">
              <div class="col-md-4">
                <i class="fa fa-file icon-dash bg-gradient"></i>
              </div>
              <div class="col-md-8 text-end textoNumeral">{{ dashboard.totalClientes }}</div>
              <div class="col-md-12 text-end">
                <span class="textoExplicativo">Total de clientes</span>
              </div>
            </div>
          </div>
          <div class="col-3 icons bordas">
            <div class="row">
              <div class="col-md-4">
                <i class="fa fa-file-pdf-o icon-dash bg-gradient"
                   style="background-color: #6E8898; border-color: #6E8898"></i>
              </div>
              <div class="col-md-8 text-end textoNumeral">{{ dashboard.totalTarefasAgendadasHoje }}</div>
              <div class="col-md-12 text-end">
                <span class="textoExplicativo">Total de tarefas para hoje</span>
              </div>
            </div>
          </div>
          <div class="col-3 icons bordas">
            <div class="row">
              <div class="col-md-4">
                <i class="fa fa-check icon-dash bg-gradient"
                   style="background-color: #ea4330; border-color: #ea4330"></i>
              </div>
              <div class="col-md-8 text-end textoNumeral">{{ dashboard.totalAtendimentosContatoInicialHoje }}</div>
              <div class="col-md-12 text-end">
                <span class="textoExplicativo">Total de contatos iniciais hoje</span>
              </div>
            </div>
          </div>
          <div class="col-3 icons bordas">
            <div class="row">
              <div class="col-md-4">
                <i class="fa fa-user icon-dash bg-gradient"
                   style="background-color: #46911b; border-color: #46911b"></i>
              </div>
              <div class="col-md-8 text-end textoNumeral">{{ dashboard.totalAtendimentosAgendadoHoje }}</div>
              <div class="col-md-12 text-end">
                <span class="textoExplicativo">Total de atendimentos agendados de hoje</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="p-0 g-0 col-md-9">
          <app-calendario
            [evento]="true"
            titulo="Minhas tarefas"
          ></app-calendario>
        </div>
        <div class="col-md-3" style="padding:23px 5px 20px 20px;">
          <app-crm-dashboard-list></app-crm-dashboard-list>
        </div>
      </div>
    </div>
  </section>
</div>
